import { useState } from "react";
import { EntityManager } from "@/components/EntityManager";
import { InvoiceUploader } from "@/components/InvoiceUploader";
import { BulkInvoiceUploader } from "@/components/BulkInvoiceUploader";
import { ENTITY_CONFIG } from "@/lib/entities";
import { Card } from "@/components/ui/card";
import { Sparkles } from "lucide-react";

export default function Payables() {
  const [reloadKey, setReloadKey] = useState(0);
  const bump = () => setReloadKey((k) => k + 1);
  return (
    <div className="space-y-6">
      <Card
        className="p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
        data-testid="invoice-upload-bar"
      >
        <div className="flex items-center gap-2 min-w-0">
          <Sparkles className="h-4 w-4 text-brand2 shrink-0" />
          <p className="text-sm text-muted-foreground">
            <span className="font-medium text-foreground">Add invoices</span> — AI reads vendor, GST, date &amp; amount. Review before posting.
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <InvoiceUploader onPosted={bump} />
          <BulkInvoiceUploader onPosted={bump} />
        </div>
      </Card>
      <EntityManager key={reloadKey} config={ENTITY_CONFIG.payables} />
    </div>
  );
}
